// extracted by mini-css-extract-plugin
module.exports = {"iconPositionInTable":"style_iconPositionInTable__3ou9o","dropdown":"style_dropdown__2qPTz","avatar":"style_avatar__1kep5","menuIcon":"style_menuIcon__2j7O1"};